export const formatLatency = (ms) => {
    if (ms < 1000)
        return `${Math.round(ms)}ms`;
    return `${(ms / 1000).toFixed(1)}s`;
};
export const formatDateTime = (dateString) => {
    return new Date(dateString).toLocaleString('ja-JP');
};
export const getStatusColor = (agent) => {
    if (!agent.isActive)
        return 'bg-gray-100 text-gray-800';
    if (!agent.stats)
        return 'bg-blue-100 text-blue-800';
    if (agent.stats.errorCount === 0 && agent.stats.totalCalls > 0)
        return 'bg-green-100 text-green-800';
    if (agent.stats.totalCalls === 0)
        return 'bg-blue-100 text-blue-800';
    const errorRate = (agent.stats.errorCount / agent.stats.totalCalls) * 100;
    if (errorRate > 10)
        return 'bg-red-100 text-red-800';
    if (errorRate > 5)
        return 'bg-yellow-100 text-yellow-800';
    return 'bg-green-100 text-green-800';
};
export const getStatusText = (agent) => {
    if (!agent.isActive)
        return '停止中';
    if (!agent.stats || agent.stats.totalCalls === 0)
        return '未使用';
    const errorRate = (agent.stats.errorCount / agent.stats.totalCalls) * 100;
    if (errorRate > 10)
        return '問題あり';
    if (errorRate > 5)
        return '注意';
    return '正常';
};
export const mapDiveAgentToAIAgent = (agent) => {
    const agentId = agent.agent_id || agent.id || agent.name || `agent_${Math.random().toString(36).slice(2, 8)}`;
    const endpointPath = agent.customEndpointPath || agent.endpointPath || agent.endpoint || `/api/custom/agents/${agentId}`;
    return {
        id: String(agentId),
        name: agent.name || String(agentId),
        description: agent.description || agent.config?.description || '',
        category: agent.category || 'Dive',
        endpointPath,
        endpoint: endpointPath,
        method: agent.method === 'GET' ? 'GET' : 'POST',
        systemPrompt: agent.config?.system_prompt || '',
        userPromptTemplate: undefined,
        parameters: Array.isArray(agent.parameters) ? agent.parameters : [],
        authRequired: Boolean(agent.authRequired),
        isActive: true,
        tags: Array.isArray(agent.tags) ? agent.tags : [],
        createdAt: agent.created_at || new Date().toISOString(),
        updatedAt: agent.updated_at || new Date().toISOString(),
        stats: {
            totalCalls: 0,
            successfulCalls: 0,
            errorCount: 0,
            averageLatency: 0,
            lastUsedAt: undefined,
        },
        isDive: true,
        config: agent.config,
        diveModel: agent.config?.llm_config?.model_name || agent.config?.llm_config?.model,
        diveTemperature: agent.config?.llm_config?.temperature,
        diveCreatedBy: agent.created_by || agent.updated_by,
        agentType: agent.agent_type || undefined,
        slug: agent.slug || undefined,
        license: agent.license || undefined,
        origin: agent.origin || undefined,
        // Kusanagi の status（ライフサイクル）。isActive/stats 由来の表示用ステータスとは別概念
        lifecycleStatus: agent.status || undefined,
    };
};
